import { useStore } from "../store";

export const formatPrice = (price) => {
  const settings = useStore.getState().settings;
  return new Intl.NumberFormat(settings.language, {
    style: "currency",
    currency: settings.currency,
  }).format(price / 100);
};
